<template lang="pug">
  FormModal(title="Edit Call to Action", method="PUT", :endpoint="`blocks/${block_id}`", :data="data", v-bind="$attrs", @success="onSuccess")
    InputGroup(label="Text", name="text")
      TextInput(v-model="data.call_to_action_text", prepend-icon="block-cta", auto-focus)
    InputGroup(label="URL", name="url")
      TextInput(v-model="data.content_url", prepend-icon="link")
    InputGroup(v-if="!collection_id", name="collection_ids", label="Collection(s) - optional", description="Click the chevron or your down arrow key to see list")
      MultiSelect(v-model="data.collection_ids", placeholder="Add this to a collection...", endpoint="options/all/collections", option-label="label")
</template>

<script>
export default {
  props: {
    block_id: {
      type: Number,
      required: true
    },
    collection_id: {
      type: Number
    }
  },
  data: () => ({
    data: {
      collection_id: null,
      collection_ids: [],
      call_to_action_text: "",
      content_url: ""
    }
  }),
  async created() {
    this.data.collection_id = this.collection_id

    let params = this.collection_id ? `?collection_id=${this.collection_id}` : ""
    let response = await this.$api.get(`blocks/${this.block_id}${params}`)

    this.data.call_to_action_text = response.data.data.text
    this.data.content_url = response.data.data.url
    this.data.collection_ids = response.data.data.collection_ids
  },
  methods: {
    onSuccess(result) {
      this.$notification.success(`Call to action successfully updated.`)
      this.$emit("close", result)
    }
  }
}
</script>
